export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const DIRECT_SEARCH_START = 'DIRECT_SEARCH_START';
export const DIRECT_SEARCH_SUCCESS = 'DIRECT_SEARCH_SUCCESS';
export const DIRECT_SEARCH_FAILURE = 'DIRECT_SEARCH_FAILURE';

export const CREATE_START = 'CREATE_START';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILURE = 'CREATE_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const DESTROY_START = 'DESTROY_START';
export const DESTROY_SUCCESS = 'DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'DESTROY_FAILURE';

export const CONNECTION_START = 'CONNECTION_START';
export const CONNECTION_SUCCESS = 'CONNECTION_SUCCESS';
export const CONNECTION_FAILURE = 'CONNECTION_FAILURE';

export const NODE_DOMAIN_RANDOMIZABLE_ACCOUNT_START = 'NODE_DOMAIN_RANDOMIZABLE_ACCOUNT_START';
export const NODE_DOMAIN_RANDOMIZABLE_ACCOUNT_SUCCESS = 'NODE_DOMAIN_RANDOMIZABLE_ACCOUNT_SUCCESS';
export const NODE_DOMAIN_RANDOMIZABLE_ACCOUNT_FAILURE = 'NODE_DOMAIN_RANDOMIZABLE_ACCOUNT_FAILURE';

export const CLEAR_WORK = 'CLEAR_WORK';

export const RESET_ERROR = 'RESET_ERROR';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
